import React, { Component } from 'react';
import { connect } from 'react-redux';
// import SwipeableViews from 'react-swipeable-views';
// import { View, ScrollView, StyleSheet } from 'react-native'
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';

import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import shared from '../../utils/shared.js'
var spacialEvents;

class Timeline extends Component {

    constructor(props) {
        super(props);
        this.refDict = {};
        this.cycleDate = this.cycleDate.bind(this);
        this.onScrollEnd = this.onScrollEnd.bind(this);
        this.state = {
            spacialEvents: null,
            sideMargin: null,
            totalWidth: null,
            currentEvent: 0
        }
    }

    componentWillMount(){
        shared.checkData(this.props.module);
    }

    componentDidMount() {
        let totalWidth = this.props.module.contents.events.length*(this.props.screen.r16_9.width/10) + this.props.screen.r16_9.width; //better mechanism for full width, # of points?
        this.getRelativeLocations(this.props.module.contents.events, totalWidth, this.props.screen.r16_9.width / 2)
    }

    componentDidUpdate() {

    }

    // shouldComponentUpdate(){
    //     return false;
    // }

    getRelativeLocations(events, totalWidth, sideMargin) {


        spacialEvents = [];

        if (this.props.module.contents.event_spacing==="even"){
            let iWidth = totalWidth - (sideMargin * 2)
            let eventInc = iWidth/events.length;
            _.forEach(events, (event, index) => {
                let raw = eventInc*index;
                let span = raw + sideMargin;
                spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date*1000)), offset: span, raw: raw, text: event.text, images: event.images })        
            });
            this.setState({
                spacialEvents: spacialEvents,
                sideMargin: sideMargin,
                totalWidth: totalWidth
            })
        }
        else{ //relative spacing
            let iWidth = totalWidth - (sideMargin * 2)
            let fullTimeSpan = events[events.length - 1].date - events[0].date;
            _.forEach(events, (event) => {
                let raw = (((event.date - events[0].date) / fullTimeSpan) * iWidth)
                let span = raw + sideMargin;
                spacialEvents.push({ header: event.header, date: this.parseDate(new Date(event.date*1000)), offset: span, raw: raw, text: event.text, images: event.images })
            });
            this.setState({
                spacialEvents: spacialEvents,
                sideMargin: sideMargin,
                totalWidth: totalWidth
            })
        }
    }

    parseDate = (date) => {

        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        let monthName =  monthNames[date.getMonth()]
        let monthNumber = String(date.getMonth()+1);
        let fullYear = String(date.getFullYear());
        let shortYear = fullYear.substring(2);
        let day = String(date.getDate());
        switch (this.props.module.contents.date_format){
            case "yyyy":
            return fullYear;
            case "mmm-yyyy":
            return monthName+"-"+fullYear;
            case "mm-dd-yyyy":
            return monthNumber+"-"+day+"-"+fullYear;
            case "yy":
            return shortYear
            case "mmm-yy":
            return monthName+"-"+shortYear;
            case "mm-dd-yy":
            default:
            return monthNumber+"-"+day+"-"+shortYear;
        }
    }

    onScrollEnd(e) {
        let xVal = Math.abs(e.x);
        let tempCurrentEvent = 0;
        let closestDist = null; //always pinning first to zero

        for (var i = 0; i < spacialEvents.length; i++) {
            let dist = Math.abs(spacialEvents[i].raw - xVal);
            if (closestDist === null) {
                tempCurrentEvent = i;
                closestDist = dist;
            }
            else {
                if (dist < closestDist) {
                    tempCurrentEvent = i;
                    closestDist = dist;
                }
            }
        }

        this.refDict[0].withIScroll(function (iScroll) {
            iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
        })
        this.setState({
            currentEvent: tempCurrentEvent
        })
    }

    cycleDate(mode, index) {
        let tempCurrentEvent = this.state.currentEvent;
        if (mode === 0) { //backward
            tempCurrentEvent--;
            if (tempCurrentEvent < 0) {
                tempCurrentEvent = spacialEvents.length - 1;
            }
        }
        else if (mode === 1) { //forward
            tempCurrentEvent++;
            if (tempCurrentEvent > spacialEvents.length - 1) {
                tempCurrentEvent = 0;
            }
        }
        else{ //to specific index
            tempCurrentEvent = index;
        }
        this.refDict[0].withIScroll(function (iScroll) {
            iScroll.scrollTo(-(spacialEvents[tempCurrentEvent].raw), 0, 1000);
        })
        this.setState({
            currentEvent: tempCurrentEvent
        })
    }

    renderSpacialEvents(tHeight) {

        let circleRadius = this.props.screen.r16_9.p10 * 0.4
        let imageWidth = this.props.screen.r16_9.p10 * 1.7

        let circle = {
            width: circleRadius,
            height: circleRadius,
            WebkitBorderRadius: circleRadius / 2,
            MozBorderRadius: circleRadius / 2,
            borderRadius: circleRadius / 2,
            background: 'white',
            position: 'absolute',
            top: tHeight - this.props.screen.r16_9.p10 * 0.75,
            left: -circleRadius / 2
        }

            if (this.state.spacialEvents.length === 0){
                return (
                    <span />
                )        
            }

        return (
            this.state.spacialEvents.map(function (row, i) {
                if (this.state.currentEvent === i) {
                    //console.log(row); //TODO: this is triggering too often, see on component did update
                    let rowWidth = this.props.screen.r16_9.p10 * 6
                    if (row.text.length>150){
                        rowWidth = this.props.screen.r16_9.p10 * 10
                    }
                    return (
                        <span key={i} style={{ position: 'absolute', left: row.offset, zIndex: 1 }}>
                            <span className="fade_on_load">
                                <span style={{ position: 'absolute', left: -rowWidth/2, fontSize: this.props.screen.r16_9.p10 * 0.45, textAlign: 'center', width: rowWidth }}>{row.date}</span>

                                <span style={{ position: 'absolute', left: -rowWidth/2, top: this.props.screen.r16_9.p10/2, fontSize: this.props.screen.r16_9.p10 * 0.35, textAlign: 'center', width: rowWidth }}>{row.header}</span>                  

                                <span style={{ position: 'absolute', top: this.props.screen.r16_9.p10*1.25, left: -rowWidth/2, fontSize: this.props.screen.r16_9.p10 / 4, display: 'inline-flex', width: rowWidth, height: this.props.screen.r16_9.p10 }}>{row.text}</span>
                                <span style={{ position: 'absolute', top: tHeight - this.props.screen.r16_9.p10 * 1.5, width: this.props.screen.r16_9.p10 * .1, height: this.props.screen.r16_9.p10, left: -this.props.screen.r16_9.p10 * .05, backgroundColor: 'white' }} />
                                <img alt="event" src={this.props.screen.dpath + row.images[0].path + row.images[0].file_name} style={{ position: 'absolute', top: tHeight - this.props.screen.r16_9.p10 * 3, left: -imageWidth / 2, width: imageWidth, height: imageWidth }} />
                            </span>
                            <span style={{ ...circle }} />
                        </span>
                    )
                }
                else {
                    return (
                        <span key={i} style={{ position: 'absolute', left: row.offset, zIndex: 0 }}>

                            <span style={{ position: 'absolute', fontSize: this.props.screen.r16_9.p10 * 0.45, top: tHeight - this.props.screen.r16_9.p10 * 4,height: this.props.screen.r16_9.p10*3, width: 1, textAlign: 'center' }}>
                                <span style={{right: this.props.screen.r16_9.p10*.3, top: 0, width: this.props.screen.r16_9.p10*3, textAlign: 'left'}} className="rotate90">{row.date}</span>
                            </span>

                            <span style={{ ...circle }} />
                        </span>
                    )
                }
            }, this)
        )
    }

    renderQuickJumps() {

        let iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' }
        let iconStyleActive = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .75' }

        return (
            this.state.spacialEvents.map(function (row, i) {
                if (this.state.currentEvent === i) {
                    return (
                        <span key={i} style={{ display: 'inline-block', width: this.props.screen.r16_9.p10*.6,  position: 'relative', fontSize: this.props.screen.r16_9.p10 }}>
                            <span className="phand" style={iconStyleActive}><FontAwesome name='circle' /></span>
                        </span>
                    )
                }
                else {
                    return (
                        <span onMouseDown={(e) => this.cycleDate(2, i)} key={i} style={{ display: 'inline-block', width: this.props.screen.r16_9.p10*.6, position: 'relative', fontSize: this.props.screen.r16_9.p10 / 2 }}>
                            <span className="phand" style={iconStyle}><FontAwesome name='circle' /></span>
                        </span>
                    )
                }
            }, this)
        )
    }

    render() {
        let iconStyle = { fontSize: this.props.screen.screenHeight * .05, color: 'rgba(255,255,255, .25' }
        if (!this.state.spacialEvents) {
            return <div />
        }

        let cycleDateStyle = {
            color: 'white',
            height: this.props.screen.screenHeight * .06,
            fontSize: this.props.screen.screenHeight * .06,
            zIndex: 99,
        }

        let tTop = this.props.screen.screenHeight * .15
        let tHeight = this.props.screen.screenHeight * .6
        let relativeLocations = this.renderSpacialEvents(tHeight);
        let quickJumps = this.renderQuickJumps();
        return (
            <div style={{ position: 'fixed', top: tTop, left: this.props.screen.r16_9.left, height: tHeight, width: this.props.screen.r16_9.width, touchAction:"none" }}>
                <ReactIScroll ref={el => this.refDict[0] = el} iScroll={iScroll}
                    onScrollEnd={this.onScrollEnd}
                    onRefresh={this.onRefresh}
                    options={{ 
                        mouseWheel: true, 
                        scrollbars: false, 
                        scrollX: true, 
                        probeType: 2, 
                        bounce: false, 
                        momentum: true,
                        deceleration: 0.015,
                        useTransition: true,
                        disableTouch: false,
                        disablePointer: false, 
                        disableMouse: false
                        }}>

                    <div style={{ width: this.state.totalWidth, height: tHeight }}>
                        {relativeLocations}
                    </div>
                </ReactIScroll>
                <div style={{ position: 'absolute', bottom: this.props.screen.r16_9.p10 * .5, backgroundColor: 'white', width: this.props.screen.r16_9.width, height: this.props.screen.r16_9.p10 * .1 }}></div>
                <div style={{ textAlign: 'center', margin: '0 auto' }}>
                    <span className="phand" style={cycleDateStyle}>
                        <span className="phand" onMouseDown={(e) => this.cycleDate(0)} style={iconStyle}><FontAwesome name='arrow-circle-left' /></span>
                    </span>
                    <span style={{dislay: 'inline-block', width: this.props.screen.r16_9.p10*.1}}>&nbsp;</span>
                    {quickJumps}
                    <span style={{dislay: 'inline-block', width: this.props.screen.r16_9.p10*.1}}>&nbsp;</span>
                    <span className="phand" style={cycleDateStyle}>
                        <span className="phand" onMouseDown={(e) => this.cycleDate(1)} style={iconStyle}><FontAwesome name='arrow-circle-right' /></span>
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {

    let dm;
    if (state.options.idleModule || state.options.idleModule===0){
        dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data       
    }
    else{
        dm = state.content.dm_active[state.active_module]
    }

    return {
        content: state.content,
        screen: state.screen,
        module: dm
    }
}

export default connect(mapStateToProps, null)(Timeline)


// WEBPACK FOOTER //
// ./src/Components/Timeline/Timeline.js